




























































    import { Component, Vue } from "vue-property-decorator";
    import { EventBus } from '@/utils/eventBus.js';
    import { scrollToTop, coordMaps } from '@/utils/index.js';

	@Component({
		components: {}
	})
	export default class Footer extends Vue {
		private officialWechat: any = 'https://appd.knowbox.cn/ss/activity/knowbox-web/img/wechat2.png';

		private schoolAppList: any = [
			{
				name: '小盒老师',
                url: 'teacher',
                query: 'block=teacher'
			},
			{
				name: '小盒学生',
                url: 'student',
                query: 'block=student'
            },
            {
				name: '小盒家长',
                url: 'parent',
                query: 'block=parent'
			},
			{
				name: '小盒课堂',
                url: 'aiclass',
                official: 'https://xiaoheketang.knowbox.cn'
			},
			// {
			// 	name: "家校盒子",
			// 	url: "school-family"
			// },
			// {
			// 	name: "小象数据",
			// 	url: "xiaoxiangshuju"
			// }
		];
		// private familyAppList: any = [
		// 	{
		// 		name: '小象编程',
		// 		url: 'program',
        //         official: 'https://code.knowbox.cn'
		// 	},
		// 	// {
		// 	// 	name: '小象英语',
        //     //     url: 'english',
        //     //     query: 'block=english' 
		// 	// },
		// 	// {
		// 	// 	name: '小象科学',
        //     //     url: 'science',
        //     //     query: 'block=science'
		// 	// },
		// 	{
		// 		name: '拍作业',
        //         url: 'ocr',
        //         query: 'block=ocr'
		// 	}
        // ];

        private jump(path: any) {
            EventBus.$emit('router.change', path);

            this.$router.push({
                path
            });

            this.doScroll(path);
        }
        
        private handleClick(item: any) {
            EventBus.$emit('router.change', '/product');

            if (item.url !== 'aiclass' && item.url !== 'program') {
                this.$router.push({
                    path: `/product?${item.query}`
                });

                this.doScroll('/product');
            } else {
                window.open(item.official);
            }
        }

        private doScroll(path: any) {
            if (this.$route.path === path.replace(/\?.*/, '')) {
                let coord = 0;

                if (path.includes('?block=')) {
                    const match = path.match(/\?block=(.*)/); 
                    const key = match ? match[1] : 0;

                    coord = coordMaps[key];
                }

                scrollToTop(coord);
            }
        }
	}
